import { connect } from 'react-redux';
import Index from './Index';

import { fetchRecipes } from '../service/recipes';
import { recipesReceived } from '../store';

const mapStateToProps = (state) => ({
    recipes: state.recipes
});

const mapDispatchToProps = dispatch => ({
    loadRecipes: () => (
        fetchRecipes()
            .then(list => {
                dispatch(recipesReceived(list.recipes));
                return true;
            })
            .catch(e => {
                console.error(e);
                return false;
            })
    )
});

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(Index);



// WEBPACK FOOTER //
// ./src/components/Index.container.js